import { createContext } from 'react';

export interface SettingsTaskContextValue {
  taskCount: number;
  setTaskCount: (count: number) => void;
  hasLoaded: boolean;
}

export const SettingsTaskContext = createContext<SettingsTaskContextValue>({
  taskCount: 0,
  setTaskCount: () => undefined,
  hasLoaded: false,
});
